<head>
  <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Open+Sans" />
</head>
<div class="inner">
  <div class="row login-form">
    <div class="text-center logo">
      <img src="../../../assets/images/logo.png" />
    </div>
  </div>
</div>

<div id="container">
<div id="google-btn" class="g_id_signin custom"></div>
</div>
